import { Sidebar } from "primereact/sidebar";
import React from "react";
import { useTranslation } from "react-i18next";
import SharedButton from "../components/Shared/SharedButton";
import { useSelector } from "react-redux";
import { Calendar } from "primereact/calendar";
import DropdownComponent from "../components/Shared/DropdownComponent";
import DatePicker from "../components/Shared/DatePicker";

const Filters = ({
  visible,
  setVisible,
  filters,
  setFilters,
  fetchData,
  loading,
  type = "store",
  storageKey = "",
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state?.auth);
  const handleUpdateFilters = () => {
    localStorage.setItem(storageKey, JSON.stringify(filters));
    fetchData(filters);
    setVisible(false);
  };
  const handleResetFilters = () => {
    const resetFilters = {
      orderDateFrom: null,
      orderDateTo: null,
      ...(type === "gallery"
        ? { CustomerOrderID: null }
        : { ClientOrderID: null }),
      zatcaStatus: null,
      ...(type === "gallery"
        ? { galleryId: user?.thirdparty_branch_id }
        : { storeId: user?.thirdparty_branch_id }),
      page: 1,
      pageSize: 10,
    };
    localStorage.setItem(storageKey, JSON.stringify(resetFilters));
    setFilters(resetFilters);
    fetchData(resetFilters);
    setVisible(false);
  };

  return (
    // <div className="mt-6">
    //   <Sidebar
    //     visible={visible}
    //     position="right"
    //     header={t("filter")}
    //     onHide={() => setVisible(false)}
    //     pt={{
    //       header: { className: "!justify-between text-[20px] font-[500]" },
    //       root: {
    //         className:
    //           "w-full sm:w-[350px] mt-[100px] h-[100vh] md:mt-[170px] xl:mt-[100px]",
    //       },
    //     }}
    //   >
    <div className="flex flex-col md:flex-row md:items-center mb-2 gap-2 justify-end">

      <DatePicker
        className="w-full sm:!w-[260px]"
        placeholder={t("Order Date From")}
        useFormik={false}
        value={filters?.orderDateFrom ? new Date(filters.orderDateFrom) : null}
        onChange={(e) =>
          setFilters((prev) => ({
            ...prev,
            orderDateFrom: e.value
              ? new Date(
                  e.value.getTime() - e.value.getTimezoneOffset() * 60000,
                ).toISOString()
              : null,
          }))
        }
      />

      <DatePicker
        className="w-full  sm:!w-[260px]"
        placeholder={t("Order Date To")}
        useFormik={false}
        value={filters.orderDateTo ? new Date(filters.orderDateTo) : null}
        onChange={(e) =>
          setFilters((prev) => ({
            ...prev,
            orderDateTo: e.value
              ? new Date(
                  e.value.getTime() - e.value.getTimezoneOffset() * 60000,
                ).toISOString()
              : null,
          }))
        }
      />
      <div className="">
        <input
        placeholder={t("Client Order ID")}
          id="ClientOrderID"
          type="number"
          className="input-field w-full sm:!w-[260px] !mt-0"
          value={filters.ClientOrderID || filters.CustomerOrderID || ""}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              ...(type === "gallery"
                ? { CustomerOrderID: Number(e.target.value) }
                : { ClientOrderID: Number(e.target.value) }),
            }))
          }
        />
      </div>

      <DropdownComponent
        useFormik={false}
        value={filters?.zatcaStatus}
        options={[
          { label: t("All"), value: "" },
          { label: t("REPORTED"), value: "REPORTED" },
          { label: t("UNREPORTED"), value: "UNREPORTED" },
        ]}
        handleChange={(e) =>
          setFilters((prev) => ({
            ...prev,
            zatcaStatus: e.value,
          }))
        }
        placeholder={t("ZATCA Status")}
        showClear
        className="w-full sm:!w-[260px]"
      />
      {/* <div className=''>
            <label htmlFor='providerId'>{t('Provider ID')}</label>
            <input
              id='providerId'
              type='text'
              className='w-full border rounded-md p-1.5'
              value={filters.providerId || ''}
              onChange={e =>
                setFilters(prev => ({ ...prev, providerId: e.target.value }))
              }
            />
          </div>
          <div className=''>
            <label htmlFor='providerBranchId'>{t('Provider Branch ID')}</label>
            <input
              id='providerBranchId'
              type='text'
              className='w-full border rounded-md p-1.5'
              value={filters.providerBranchId || ''}
              onChange={e =>
                setFilters(prev => ({
                  ...prev,
                  providerBranchId: e.target.value
                }))
              }
            />
          </div> */}
      <div className="flex items-center gap-2">
        <SharedButton
          disabled={loading}
          title={t("apply_filters")}
          icon="pi pi-filter"
          onClick={handleUpdateFilters}
        />
        <SharedButton
          icon="pi pi-sync"
          buttonType="reset"
          title={t("Reset filters")}
          onClick={handleResetFilters}
        />
      </div>
      {/* </Sidebar> */}
    </div>
  );
};

export default Filters;
